//小数点分割
export function xiaoshudianfenge(inputValue, tempUserSetting) {
    if (isNaN(parseFloat(inputValue))) {
        inputValue = 0.00;
    } else {
        inputValue = toThousandsNoZero(inputValue, tempUserSetting);
    }
    return inputValue;
}

//小数点分割
export function toThousandsNoZero(num, tempUserSetting) {
    // let tempUserSetting = this.userSetting;

    if (num) {
        let resultMoney = ((isNaN(parseFloat(num.toString().replace(/,/g, ""))) ? 1 : parseFloat(num.toString().replace(/,/g, "")))).toFixed(tempUserSetting.currencyDecimalPlaces).toString().replace(/(\d)(?=(\d{3})+\.)/g,
            function ($0, $1) {
                return $1 + tempUserSetting.currencyThousandSymbol;
            });
        return formatMoney(resultMoney, tempUserSetting);
    } else {
        return formatMoney(0, tempUserSetting);
    }
}

export function formatMoney(resultMoney, tempUserSetting) {
    if (tempUserSetting.currencyPlacementAtBefore == 1) {
        return tempUserSetting.currency + resultMoney;
    } else {
        return resultMoney + tempUserSetting.currency;
    }
}


